import type { ComponentConfigV2, InteractiveOptions, InteractiveKind } from '@/types/configurationV2'

export default function InteractiveOptionsEditor({
  component,
  onUpdate,
}: { component: ComponentConfigV2; onUpdate: (u: ComponentConfigV2) => void }) {
  const options = component.options as InteractiveOptions
  const setKind = (kind: InteractiveKind) =>
    onUpdate({ ...component, options: { ...options, kind } })

  const groupName = `interactive-kind-${component.id}`

  return (
    <div className="space-y-2">
      <label className="flex items-center gap-1.5 text-xs">
        <input
          type="radio"
          name={groupName}
          checked={options.kind === 'tool'}
          onChange={() => setKind('tool')}
        />
        Tool
      </label>
      <label className="flex items-center gap-1.5 text-xs">
        <input
          type="radio"
          name={groupName}
          checked={options.kind === 'game'}
          onChange={() => setKind('game')}
        />
        Game (준비중)
      </label>
      <div className="text-xs text-gray-400">
        학생 화면에서 렌더되는 인터렉티브 콘텐츠 종류.
        Game은 향후 지원 예정이며 현재는 학생 화면에서 노출되지 않습니다.
      </div>
    </div>
  )
}
